module.exports = __webpack_public_path__ + "img/product4.4251e5da.png";